import type { CasOrCategory } from '../types/db.ts';
import type { TRIToxicEquivalencyIdentificationType } from '../types/form-r.ts';

export const dioxinsCategory = 'N150' as CasOrCategory;

export const dioxinCongeners = new Set<CasOrCategory>([
  '1746-01-6', // 2,3,7,8-Tetrachlorodibenzo-p-dioxin (abbr: 2,3,7,8-TCDD)
  '40321-76-4', // 1,2,3,7,8-Pentachlorodibenzo-p-dioxin (abbr: 1,2,3,7,8-PeCDD)
  '39227-28-6', // 1,2,3,4,7,8-Hexachlorodibenzo-p-dioxin (abbr: 1,2,3,4,7,8-HxCDD)
  '57653-85-7', // 1,2,3,6,7,8-Hexachlorodibenzo-p-dioxin (abbr: 1,2,3,6,7,8-HxCDD)
  '19408-74-3', // 1,2,3,7,8,9-Hexachlorodibenzo-p-dioxin (abbr: 1,2,3,7,8,9-HxCDD)
  '35822-46-9', // 1,2,3,4,6,7,8-Heptachlorodibenzo-p-dioxin (abbr: 1,2,3,4,6,7,8-HpCDD)
  '3268-87-9', // 1,2,3,4,6,7,8,9-Octachlorodibenzo-p-dioxin (abbr: 1,2,3,4,6,7,8,9-OCDD)
  '51207-31-9', // 2,3,7,8-Tetrachlorodibenzofuran (abbr: 2,3,7,8-TCDF)
  '57117-41-6', // 1,2,3,7,8-Pentachlorodibenzofuran (abbr: 1,2,3,7,8-PeCDF)
  '57117-31-4', // 2,3,4,7,8-Pentachlorodibenzofuran (abbr: 2,3,4,7,8-PeCDF)
  '70648-26-9', // 1,2,3,4,7,8-Hexachlorodibenzofuran (abbr: 1,2,3,4,7,8-HxCDF)
  '57117-44-9', // 1,2,3,6,7,8-Hexachlorodibenzofuran (abbr: 1,2,3,6,7,8-HxCDF)
  '72918-21-9', // 1,2,3,7,8,9-Hexachlorodibenzofuran (abbr: 1,2,3,7,8,9-HxCDF)
  '60851-34-5', // 2,3,4,6,7,8-Hexachlorodibenzofuran (abbr: 2,3,4,6,7,8-HxCDF)
  '67562-39-4', // 1,2,3,4,6,7,8-Heptachlorodibenzofuran (abbr: 1,2,3,4,6,7,8-HpCDF)
  '55673-89-7', // 1,2,3,4,7,8,9-Heptachlorodibenzofuran (abbr: 1,2,3,4,7,8,9-HpCDF)
  '39001-02-0', // 1,2,3,4,6,7,8,9-Octachlorodibenzofuran (abbr: 1,2,3,4,6,7,8,9-OCDF)
] as CasOrCategory[]);

export const dioxinCongenerToFormRField = {
  '1746-01-6': 'ToxicEquivalency1Value',
  '40321-76-4': 'ToxicEquivalency2Value',
  '39227-28-6': 'ToxicEquivalency3Value',
  '57653-85-7': 'ToxicEquivalency4Value',
  '19408-74-3': 'ToxicEquivalency5Value',
  '35822-46-9': 'ToxicEquivalency6Value',
  '3268-87-9': 'ToxicEquivalency7Value',
  '51207-31-9': 'ToxicEquivalency8Value',
  '57117-41-6': 'ToxicEquivalency9Value',
  '57117-31-4': 'ToxicEquivalency10Value',
  '70648-26-9': 'ToxicEquivalency11Value',
  '57117-44-9': 'ToxicEquivalency12Value',
  '72918-21-9': 'ToxicEquivalency13Value',
  '60851-34-5': 'ToxicEquivalency14Value',
  '67562-39-4': 'ToxicEquivalency15Value',
  '55673-89-7': 'ToxicEquivalency16Value',
  '39001-02-0': 'ToxicEquivalency17Value',
} as Record<CasOrCategory, Exclude<keyof TRIToxicEquivalencyIdentificationType, 'ToxicEquivalencyNAIndicator'>>;

export const dioxinCongenerToIndex = {
  '1746-01-6': 1,
  '40321-76-4': 2,
  '39227-28-6': 3,
  '57653-85-7': 4,
  '19408-74-3': 5,
  '35822-46-9': 6,
  '3268-87-9': 7,
  '51207-31-9': 8,
  '57117-41-6': 9,
  '57117-31-4': 10,
  '70648-26-9': 11,
  '57117-44-9': 12,
  '72918-21-9': 13,
  '60851-34-5': 14,
  '67562-39-4': 15,
  '55673-89-7': 16,
  '39001-02-0': 17,
} as Record<CasOrCategory, number>;

export const dioxinToxicEquivalencyFields = [
  'ToxicEquivalency1Value',
  'ToxicEquivalency2Value',
  'ToxicEquivalency3Value',
  'ToxicEquivalency4Value',
  'ToxicEquivalency5Value',
  'ToxicEquivalency6Value',
  'ToxicEquivalency7Value',
  'ToxicEquivalency8Value',
  'ToxicEquivalency9Value',
  'ToxicEquivalency10Value',
  'ToxicEquivalency11Value',
  'ToxicEquivalency12Value',
  'ToxicEquivalency13Value',
  'ToxicEquivalency14Value',
  'ToxicEquivalency15Value',
  'ToxicEquivalency16Value',
  'ToxicEquivalency17Value',
] as const;
